import landing from '@/locales/cr/landing'
import resultOrder from '@/locales/cr/result-order'
import invoice from '@/locales/cr/invoice'
import invoiceMcw from '@/locales/cr/invoice-mcw'
import currency from '@/locales/cr/currency'
import history from '@/locales/cr/history'
import genericError from '@/locales/cr/generic-error'
import buyRecharges from '@/locales/cr/buy-recharges'

export default {
  landing,
  resultOrder,
  invoice,
  invoiceMcw,
  currency,
  history,
  genericError,
  buyRecharges
}
